import { styled } from 'styled-components';

export const Badge = styled.div(
  ({ theme }) => `
  display:flex;
  align-items:flex-start;
  border-radius: 6px;
  padding: 6px 10px;
  background: ${theme.colors.badgeBackground};
  color: rgb(149 209 241 / 100%);
  width: fit-content;
  font-size:${theme.fontSizes.xxsmall};
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`,
);
